import logo_src from "../../../image/logo_light.svg";
import proposal_quiz_background from "../../../image/background.png";

export default {
  colorPrimary: "#274D5C",
  fontFamily: "Inter, sans-serif",

  background_primary: `url(${proposal_quiz_background})`,
  chart_gauge__color_empty: "#D7D8D8",
  chart_gauge__color_primary: "#559CF3",
  income_chart__color_annuities: "#00B0CB",
  income_chart__color_contributions: "#1B5568",
  income_chart__color_income_target: "#a5a3a3",
  income_chart__color_other_income: "blue",
  income_chart__color_social_security: "#002E63",
  income_chart__color_withdrawal: "#0084FF",
  income_chart__navbar_button_background: "#fff",
  income_chart__navbar_button_color: "#1E1919",
  income_chart__navbar_container_background: "#749B9E",
  logo_src,
  proposal_quiz__form_background:
    "linear-gradient(180deg, rgba(15, 41, 50, 0.72) 0%, rgba(8, 37, 48, 0.72) 100%)",
  proposal_header__background: "rgba(22, 36, 45, 0.50)",

  comparison_products_colors: ["#2A89E3", "#1E1919", "#A5A3A3"],
  proposal_header_padding: 0,
  proposal_header_height: 0,
  sidebar_avatar_background: "#e3ebeb",
  sidebar_avatar_color: "#1E1919",
  sidebar_background: "#D5E1E2",
  sidebar_icon_layout_vertical: true,
  sidebar_menu_item_hover_background: "transparent",
  sidebar_profile_color: "#215054",
  sidebar__width: 87,
  tenant_color_primary: "#E6F4EF",
};
